import React from "react";

import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import { MenuEditor } from "features/MenuEditor";
import { MenuScopeFromRouteProvider } from "shared/context/MenuScopeContext";
import { useLocale } from "shared/hooks/useLocale";
import { useMenuOptions } from "shared/hooks/useMenuOptions";
import { localizedText } from "shared/lib/localizedMap";
import { PageTitle } from "shared/ui";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/MenuEditor.
const MenuEditorPage = () => {
    const { menuId: menuIdParam } = useParams<{ menuId: string }>();
    const locale = useLocale();
    const { menuOptions } = useMenuOptions();

    const menu = menuOptions.find((item) => item.id === Number(menuIdParam));
    const title = menu ? localizedText(menu.name, locale) : "Меню";

    // Заголовок страницы ставит страница, а не фича (правило раскладки фич).

    return (
        <>
            <PageTitle>{title}</PageTitle>
            <Helmet title={title} />
            <MenuScopeFromRouteProvider>
                <MenuEditor />
            </MenuScopeFromRouteProvider>
        </>
    );
};

export default MenuEditorPage;
